export enum TypingLevels {
    CATEGORY_LEVEL = 7,
    SUBCATEGORY_LEVEL = 8,
    SUBJECT_LEVEL = 9,
}

export interface Typing {
    id: number;
    name: string;
    status: number;
    typing: number;
    level?: number;
}
